import { useSuspenseQuery } from '@tanstack/react-query';
import { tariffSummaryQueries } from '../queries/tariffSummaryQueries';
import { fetchTariffSummaryLastUpdateTime } from '../api/tariffSummaryApi';

export const useTariffSummaryLastUpdate = () => {
  return useSuspenseQuery({
    queryKey: tariffSummaryQueries.lastUpdateTimestamp(),
    queryFn: () => {
      return fetchTariffSummaryLastUpdateTime();
    },
  });
};
